<template>
  <svg height="30"
       fill="none"
       viewBox="0 0 30 30"
       width="30"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.03691 14.9232C2.77288 12.7191 2.16255 10.9193 1.79453 9.09497C1.25024 6.39679 2.49583 3.7611 4.55926 2.07932C5.43134 1.36853 6.43106 1.61138 6.94675 2.53655L8.11099 4.62523C9.0338 6.28077 9.49521 7.10855 9.40369 7.98614C9.31217 8.86374 8.68991 9.5785 7.44538 11.008L4.03691 14.9232ZM4.03691 14.9232C6.59542 19.3844 10.6105 23.4017 15.0769 25.9632M15.0769 25.9632C17.281 27.2272 19.0808 27.8376 20.9051 28.2056C23.6033 28.7499 26.239 27.5043 27.9208 25.4408C28.6316 24.5688 28.3887 23.569 27.4636 23.0533L25.3749 21.8891C23.7193 20.9663 22.8916 20.5049 22.014 20.5964C21.1364 20.6879 20.4216 21.3102 18.9921 22.5547L15.0769 25.9632Z"
      stroke="#FF3B30"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M27.0001 3L17.6667 12.3333M27.0001 12.3333L17.6667 3"
      stroke="#FF3B30"
      stroke-linecap="round"
      stroke-width="1.5"
    />
  </svg>
</template>
